module.exports = __webpack_public_path__ + "img/kr-product-supply-chain-card-bg.edfcfa9.png";